<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z3UAwQ/tc-custom/9781399003896.jpg?1705317485108" alt="This image is the cover for the book Hotspur"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hotspur
      </h1>
      <p class="bookDescription body article font2">
        <p>On 21 July 1403 Sir Henry Percy – better known as Hotspur – led a rebel army out at Shrewsbury to face the forces of the king Henry IV. The battle was both bloody and decisive. Hotspur was shot down by an arrow and killed. Posthumously he was declared a traitor and his lands forfeited to the crown. This was an ignominious end to the brilliant career of one of the most famous medieval noblemen, a remarkable soldier, diplomat and courtier who played a leading role in the reigns of Richard II and Henry IV. How did he earn his extraordinary reputation, and why did Shakespeare portray him as a fearsomely brave but flawed hero who, despite a traitor’s death, remained the mirror of chivalry? These are questions John Sadler seeks to answer in the first full biography of this legendary figure to be published for over twenty years.  Hotspur’s exploits as a soldier in France during the Hundred Years War, against the Scots in the Scottish borders and at the battles of Otterburn, Homildon Hill and Shrewsbury have overshadowed his diplomatic role as a loyal royal servant in missions to Prussia, Cyprus, Ireland and Aquitaine. And, as the heir to one of the foremost noble families of northern England, he was an important player not only in the affairs of the North but of the kingdom as a whole. So, as John Sadler reveals in this highly readable study, Hotspur was a much more varied and interesting character than his narrow reputation for headstrong attack and rebellion suggests.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Sadler, Ralph Percy
      </h2>
      
      <p class="authorDescription body article">John Sadler's main specialty is in military history, as an accomplished author, lecturer, battlefield tour guide, heritage professional and historical interpreter. He is a visiting lecturer at the University of Sunderland Centre For Lifelong Learning since 1998. He lives in the North East of England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df9feb58